import { ServiceAppointment as Appointment } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface AppointmentsState extends EntityState<Appointment> {}

export const appointmentAdapter: EntityAdapter<Appointment> = createEntityAdapter<Appointment>({
  selectId: (appointment: Appointment) => appointment.id
});
export const initialAppointmentState: AppointmentsState = appointmentAdapter.getInitialState({});
